import { REQUEST_PROFILE_TAB_EMAILS } from './RequestProfile.constants'

export function isRequestProfileTabEmails(tab) {
  return tab === REQUEST_PROFILE_TAB_EMAILS
}

export function getRequestProfilePatchMergeData(data) {
  return {
    updated: data.updated,
    updated_by: data.updated_by,
  }
}

export function getRequestProfilePreparedData(data) {
  return data
    ? {
        ...data,
        budgetPlan: data.budget_plan,
        buildingGroups: data.building_groups,
        completionTime: data.completion_time,
        createdAt: data.created,
        createdBy: data.created_by,
        finishedAt: data.closed_at,
        finishedBy: data.closed_by,
        flat: data.flat
          ? {
              ...data.flat,
              entranceAddress: data.flat?.entrance_address,
            }
          : null,
        isArchived: data.archived,
        pipelineId: data.pipeline_id,
        privateChatroom: data.private_chat_uuid,
        publicChatroom: data.public_chat_uuid,
        rating: {
          feedbackUuid: data.rating?.feedback_uuid,
          value: data.rating?.avg,
        },
        requestNumber: data.request_no,
        updatedAt: data.updated,
        updatedBy: data.updated_by,
        visibleToDwellers: data.visible_to_dwellers,
      }
    : null
}
